module.exports = __webpack_public_path__ + "static/media/close_black09e70abb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/close_black.svg
// module id = 92
// module chunks = 0